<template>
  <v-container id="workflows-page" fluid>
    <v-row>
      <v-col cols="12" class="ma-3">
        <strong class="head-title">Visualisez et paramètrez votre portail captif</strong>
      </v-col>
    </v-row>
    <v-row class="ma-3" v-if="!portalLoaded">
      <v-col cols="12">Chargement des informations du portail</v-col>
    </v-row>
    <v-row class="ma-3" v-if="portalLoaded">
      <v-col cols="5" class="bg-white left">
        <h2 class="ma-2 py-4">1. Inscription</h2>
        <v-row class="mr-3">
          <v-col cols="6">
            <h3 class="ma-2">Titre de votre portail captif</h3>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="6" align="end">
            <div class="counter pt-2" v-show="hasCharactersRemaining">
              {{ totalCharacters }}/{{ maxLength }} caractères.
            </div>
            <div :class="{ 'max-counter': !hasCharactersRemaining }" v-show="!hasCharactersRemaining">
              Limite de caractères atteinte.
            </div>
          </v-col>
        </v-row>
        <v-text-field v-model="portalData.title" @input="(v) => updatePortalData('title', v)" :maxLength="maxLength"
          class="ma-3" outlined rounded placeholder="Entrez un titre (Ex: WIFI GRATUIT)" hide-details="" />
        <v-row class="mr-3">
          <v-col cols="6">
            <h3 class="ma-2">Votre message</h3>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="6" align="end">
            <div class="counter pt-2" v-show="hasCharactersRemaining2">
              {{ totalCharacters2 }}/{{ maxLength2 }} caractères.
            </div>
            <div :class="{ 'max-counter': !hasCharactersRemaining2 }" v-show="!hasCharactersRemaining2">
              Limite de caractères atteinte.
            </div>
          </v-col>
        </v-row>

        <TextEditorTipTap :editor="editor" :value="portalData.message_content"
          @input-raw="(v) => updatePortalData('message', v)" :maxLength2="maxLength2" />

        <h3 class="ma-2">Image de l'écran d'inscription</h3>
        <v-file-input v-model="portalData.banner_image" @input="(v) => updatePortalData('banner_image', v)"
          class="ma-3 py-4" outlined rounded placeholder="Chargez votre image de header"
          accept="image/png, image/jpeg, image/bmp" hide-details="" type="file" @change="onFilePicked">
        </v-file-input>
        <h3 class="ma-2">Couleurs thématiques principales et secondaires</h3>
        <v-row class="ma-0">

          <!-- COLOR PICKER -->

          <v-col cols="6">
            <v-text-field placeholder="Votre couleur de fond primaire." rounded outlined v-model="portal.colorTitle"
              hide-details="">
              <template v-slot:append>
                <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <div :style="switchColorLeft" v-on="on" />
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-color-picker hide-details="" :value="portalData.color_primary"
                        @input="(v) => updatePortalData('color_primary', v)" flat />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field placeholder="Votre couleur de fond secondaire." rounded outlined v-model="portal.colorMessage"
              hide-details="">
              <template v-slot:append>
                <v-menu v-model="menu2" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <div :style="switchColorRight" v-on="on" />
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-color-picker hide-details="" :value="portalData.color_secondary"
                        @input="(v) => updatePortalData('color_secondary', v)" flat />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row align="center" class="ma-3 contact-covid">
          <v-col cols="9" outlined rounded>
            <strong>Recherche de cas contact</strong>
          </v-col>
          <v-spacer></v-spacer>
          <v-row align="baseline" class="pr-4">
            <v-col :class="{
                activeMarker: true,
                online: portal.switchStatus,
                offline: !portal.switchStatus,
              }" align="center" class="mb-2">
              <span>{{ portal.switchStatus ? "Activé" : "Désactivé" }}</span>
            </v-col>
            <v-switch inset :value="portalData.toggle_covid" @input="(v) => updatePortalData('toggle_covid', v)" rounded
              hide-details justify="center">
            </v-switch>
          </v-row>
        </v-row>
        <h3 class="ma-2">Programme de fidelité</h3>

        <TextEditorTipTap :editor="editor" :value="portalData.fidelity_program"
          @input-raw="(v) => updatePortalData('fidelity_program', v)" />

        <v-divider></v-divider>
        <h2 class="ma-2 py-4">2. Consultation du menu</h2>
        <h3 class="ma-2">Chargez le pdf de votre menu</h3>
        <v-file-input v-model="portal.fileInputDoc" class="ma-3 py-4" outlined rounded
          placeholder="Chargez votre menu (PDF)" accept=".pdf, .doc" hide-details="" type="file">
        </v-file-input>
        <h3 class="ma-2">
          Ou entrez directement l'url de votre menu ou site internet
        </h3>
        <v-text-field v-model="portalData.address_confidentiality"
          @input-raw="(v) => updatePortalData('address_confidentiality', v)" hide-details="" outlined rounded
          placeholder="Par défaut: www.google.fr" class="ma-3 py-4"></v-text-field>
        <v-divider></v-divider>
        <v-row justify="space-around" class="my-6">
          <v-btn @click="savePortalData()" x-large outlined class="theme-btn shape-rounded save-btn">
            <strong id="strong-btn">Sauvegarder</strong>
          </v-btn>
          <v-btn @click="" x-large class="theme-btn shape-rounded filled-purple">
            <strong>Publier</strong>
          </v-btn>
        </v-row>
        <v-row class="bg-grey pa-3">
          <strong>La sauvegarde vous permet d’enregistrer vos modifications, pour y
            revenir plus tard avant de publier votre portail captif.
            <span class="orange--text">
              Le portail captif sera actif ou mis à jour uniquement si vous
              cliquez sur publier.</span></strong>
        </v-row>
      </v-col>
      <v-col cols="7" class="pl-6">
        <v-row>
          <v-col class="right big-img" cols="12" align="center">
            <div style="position: relative; height: 800px; width: 400px">
              <v-img style="position: absolute; top: 0; left: 0" contain class="frame" width="430px" height="800px"
                src="@/assets/images/phone-modele-frame.png" />
              <v-col cols="11" class="logo px-7 py-5"><strong v-show="time"> {{ time }}
                </strong><v-spacer></v-spacer><v-icon>signal_cellular_alt</v-icon><v-icon>wifi</v-icon></v-col>

              <PhoneFrame style="
                          position: absolute;
                          top: 12px;
                          left: 1;
                          overflow: hidden;
                          height: 770px;
                          margin-left: 1px;
                      " :portal="portalData" />

              <v-col cols="11" class="div-bot px-8 py-2" style="overflow: hidden"></v-col>
            </div>
          </v-col>
          <v-col cols="12" class="pa-6">
            <v-row justify="space-around" class="ma-1">
              <v-col cols="3" class="border-modele-radius" v-for="(layout, layoutIndex) in layouts" :key="layoutIndex"
                :class="{ 'selected-model-bg': layout.bgwhite }">
                <v-img class="pt-12" contain lazy src="@/assets/images/phone-modele-frame.png"><v-row justify="center"
                    v-for="(model, modelIndex) in layout.layout" :key="modelIndex">
                    <v-col align="center" v-if="model === 'title'" class="bg-title mx-8 mt-4">Titre</v-col>
                    <v-col align="center" v-if="model === 'message'" class="bg-message mx-8">Message</v-col>
                    <v-img contain class="px-8 mt-1" v-if="model === 'image'" :src="portal.fileInputImgPreview" />
                    <v-col align="center" v-if="model === 'form'" class="bg-form mx-8">Formulaire</v-col>
                  </v-row></v-img>
                <v-row justify="space-around" class="mb-1">
                  <v-checkbox :on-icon="'radio_button_checked'" :off-icon="'radio_button_unchecked'" hide-details
                    :input-value="layout.selected" @change="setLayout(layoutIndex)" label="Modèle">
                  </v-checkbox>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PhoneFrame from "./components/phone-overview.vue";
import TextEditorTipTap from "./components/textarea-editor-tiptap.vue";
import checkDevice from "@/utils/checkDevice.js";

export default {
  components: {
    TextEditorTipTap,
    PhoneFrame,
    checkDevice,
  },
  data: () => {
    return {
      time: "",
      value: "",
      menu: false,
      menu2: false,
      color: null,
      statusCard: null,
      maxLength: 24,
      maxLength2: 280,
      editor: null,
      portal: {
        title: "WIFI GRATUIT",
        messageTop: "Entrez un message d'acceuil pour vos futurs clients",
        messageTopRaw: "Test",
        fileInputImg: null,
        fileInputImgPreview:
          "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cmVzdGF1cmFudHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
        messageBot: "",
        fileInputDoc: null,
        menuUrl: "",
        colorTitle: "#FBCEB6",
        colorMessage: "#ff7461",
        switchStatus: false,
        layout: [],
      },
      layouts: [
        {
          selected: true,
          bgwhite: true,
          layout: ["title", "message", "image", "form"],
        },
        {
          selected: false,
          bgwhite: false,
          layout: ["title", "form", "image", "message"],
        },
        {
          selected: false,
          bgwhite: false,
          layout: ["title", "image", "message", "form"],
        },
      ],
    };
  },
  computed: {

    /*
    ** PORTAL FROM STORE
    */

    portalLoading() {
      return this.$store.state.portal.portal.loading;
    },
    portalLoaded() {
      return this.$store.state.portal.portal.loaded;
    },
    portalData() {
      return this.$store.state.portal.portal.data;
    },



    /*
    ** OTHER
    */

    switchColorLeft() {
      return {
        backgroundColor: this.portal.colorTitle,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: this.menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    switchColorRight() {
      return {
        backgroundColor: this.portal.colorMessage,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: this.menu2 ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    status: {
      get() {
        return this.statusCard === null ? true : this.statusCard;
      },
      set(val) {
        this.statusCard = val;
      },
    },
    totalCharacters() {
      return this.portal.title.length;
    },
    hasCharactersRemaining() {
      return this.totalCharacters < this.maxLength;
    },
    totalCharacters2() {
      return this.portal.messageTopRaw.length;
    },
    hasCharactersRemaining2() {
      return this.totalCharacters2 < this.maxLength2;
    },
  },

  methods: {
    setLayout(index) {

      for (let i in this.layouts) {
        let cond = parseInt(i, 10) === parseInt(index, 10);
        if (cond) {
          this.portal.layout = [...this.layouts[i].layout];
        }
        this.layouts[i].selected = cond;
        this.layouts[i].bgwhite = cond;
      }
    },
    onFilePicked(file) {
      this.portal.fileInputImg = file;
      this.portal.fileInputImgPreview = URL.createObjectURL(file);
    },
    setTime() {
      this.time = new Date().toLocaleTimeString();
      setTimeout(this.setTime, 5000);
    },

    /*
    ** STORE RELATED METHODS
    */

    loadPortalData() {
      this.$store.dispatch('portal/loadPortalData', {
        parameters: {
          establishment_id: 1,
          message: "",
          address_confidentiality: "",
          fidelity_program: "",
          banner_image: null,
          status: null,
          color_main: null,
          color_secondary: null,
          toggle_covid: false
        }
      });
    },

    updatePortalData(field, value) {
      this.$store.commit('portal/setPortalDataField', {
        'field': field,
        'value': value
      });
    },

    savePortalData() {
      this.$store.dispatch('portal/upsertPortalData', {
        parameters: {
          establishment_id: 1,
          message: "",
          address_confidentiality: "",
          fidelity_program: "",
          banner_image: null,
          status: null,
          color_main: null,
          color_secondary: null,
          toggle_covid: false
        }
      });
    }


  },
  created() {
    this.loadPortalData();
    this.portal.layout = this.layouts[0].layout;
  },
  mounted: function () {
    this.setTime();
  },
};
</script>

<style lang="scss">
#workflows-page {
  background-color: #e5e4f7 !important;
}

.bg-white {
  background-color: white;
}

.bg-grey {
  background-color: #f9f9f9;
  border-bottom-left-radius: 19px;
  border-bottom-right-radius: 19px;
}

h2 {
  color: #6b5cd7;
  margin-bottom: 6px;
  margin-top: 3px;
}

h3 {
  font-weight: bold;
  margin-bottom: 6px;
}

.right {
  border: solid 7px rgba(109, 100, 255, 0.59);
  border-radius: 25px;
  background-color: #6f52ed;
  position: relative;
}

.left {
  border: solid 7px rgba(109, 100, 255, 0.59);
  border-radius: 25px;
}

.save-btn {
  border: solid #6b5cd7;
  color: #6b5cd7;
}

.switch-container-adjust {
  max-width: 60px !important;
  justify-content: end;
}

.max-counter {
  color: red;
}

.counter {
  color: $color-white-dark;
  font-weight: bold;
}

.big-img {
  overflow: hidden;
}

.contact-covid {
  border: solid 1px #d2d2d2;
  border-radius: 25px;
}

#strong-btn {
  color: #6b5cd7 !important;
}

.border-modele-radius {
  border-radius: 25px;
}

.checked {
  background-color: rgba(109, 100, 255, 0.59) !important;
}

.bg-title {
  margin-top: 6px;
  background-color: #5744e4;
  height: 45px;
  border-radius: 6px;
  color: white;
  font-weight: bold;
}

.bg-message {
  margin-top: 6px;
  background-color: #9c9ab8;
  height: 120px;
  border-radius: 6px;
  color: white;
  font-weight: bold;
}

.bg-form {
  margin-top: 6px;
  background-color: #ff7461;
  height: 50px;
  border-radius: 6px;
  color: white;
  font-weight: bold;
}

.overflow {
  overflow: hidden;
}

.head-title {
  font-size: 24px;
}

.logo {
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  background-color: white;
  display: flex;
  align-content: start;
}

.div-bot {
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  background-color: white;
  display: flex;
  position: absolute;
  margin-left: 34px;
  bottom: 13px;
  max-width: 330px;
}

.selected-model-bg {
  background-color: #9a8dfc;
}
</style>
